module.exports = __webpack_public_path__ + "img/ic-todos.05b665c0.png";